import gql from 'graphql-tag';

export default gql`
  query overlayMerchandise {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        merchandiseOverlay {
          content
          __typename
        }
        __typename
      }
    }
  }
`;
